import axios, { AxiosError } from 'axios';

import { dataFormatter } from '@/services/json-api';
import { convertObjKeys } from '@/utils/convert-obj-keys';
import { snakeCaseToCamelCase, camelCaseToSnakeCase } from '@/utils/string-casing';
import { i18n } from '@/plugins/i18n';

export const BASE_URL = import.meta.env.VITE_BASE_API_URL || 'http://localhost:3000';

export const http = axios.create({
  baseURL: BASE_URL,

  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export const getResponseErrors = (error: unknown): string[] => {
  if (error instanceof AxiosError) {
    return (
      error.response?.data?.errors?.map((err: { title: string }) => err.title) ?? [
        i18n.global.t('error.generic'),
      ]
    );
  }

  return [i18n.global.t('error.generic')];
};

http.interceptors.response.use((res) => {
  const isJsonResponse = res.headers['content-type']?.includes('application/json');
  let { data } = res;

  if (isJsonResponse && data) {
    data = convertObjKeys(data, snakeCaseToCamelCase);
    data = dataFormatter.deserialize(data);
  }

  return {
    ...res,
    links: res.data.links,
    data,
  };
});

http.interceptors.request.use((req) => {
  const isJsonRequest = String(req.headers?.['Content-Type']).includes('application/json');
  let { data } = req;

  if (isJsonRequest && data) {
    data = dataFormatter.serialize({ stuff: data });
    data = convertObjKeys(data, camelCaseToSnakeCase);
  }

  return {
    ...req,
    data,
  };
});
